import {makeAutoObservable} from "mobx";
import axios from "axios";
import fileDownload from "js-file-download";
import {EXCEL_UTIL} from "../common/util/excel/excel.util";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {base64StringToBlob} from "blob-util";


const logPrefix  = "[ExcelStore]"
export default class ExcelStore {
    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;
        this.init();
        makeAutoObservable(this);
    }

    setStepValue = (num) => {
        this.stepValue = num;
    }
    setDayValue = (num) => {
        this.dayValue = num;
    }
    initStepAndDayValue = () => {
        this.changeUploadContentState(false);
        this.setStepValue(1);
        this.setDayValue(1);
    }

    initExcelUploadRelated = () => {
        this.dialogStore.setDialogStatus(false);
        this.setCurrentUploadCount(0);
        this.setTotalUploadCount(0);
        EXCEL_UTIL.initExcelData();
        this.initErrorList();

    }

    init = () => {
        this.isReadyToUploadContent = false;
        this.currentUploadCount = 0;
        this.totalUploadCount = 0;
        this.ErrorList = [];
        this.stepValue = 1;
        this.dayValue =  1;
    }

    initErrorList = () => {
        this.ErrorList.forEach(()=>{
            this.ErrorList.pop();
        })
    }

    setErrorList = (error) => {
        this.ErrorList.push(error);
    }

    setCurrentUploadCount  = (num) => {this.currentUploadCount = num;}
    setTotalUploadCount  = (num) => {this.totalUploadCount = num;}


    changeUploadContentState = (bool) => {
        this.isReadyToUploadContent = bool;
        console.log(" this.isReadyToUploadContent :",this.isReadyToUploadContent);
    }

    getDefaultContentUrl = (step,day) => {
        return `steps/${step}/days/${day}`;
    }


    manageToRequest =  async (steps,listToCheckForDuplicate) => {
        console.log( "📘  listToCheckForDuplicate : " , listToCheckForDuplicate);
        this.setTotalUploadCount(listToCheckForDuplicate.length);
        for (const step of steps) {
            await this.requestBySteps(step);
        }
    }

    requestBySteps = async (step) => {
        console.log( "📘  requestBySteps ");
        const days = step.days
        const CurrentStep = step.step
        await this.requestContentUpload(CurrentStep,days);
    }


    requestContentUpload = (step,listToSend) => {
        console.log( "📘  requestContentUpload : " , step);
        return new Promise((resolve)=>{
            let index = 0;
            const requestUploadByDay = () => {

                if (index > listToSend.length - 1) {resolve();return;}

                const day = listToSend[index].day;
                const content = listToSend[index].list;

                if (!!content.length && content[0].allPartsWritten) {
                    this.uploadExcelContent(step,day,content,requestUploadByDay);
                } else {
                    const obj = {step:step,day:day}
                    this.setErrorList(obj);
                    this.setCurrentUploadCount(this.currentUploadCount  + 1 );
                    index++;
                    requestUploadByDay();
                }
                index++;
            };
            requestUploadByDay();
        })
    }



    *requestToCheckForExistingContents (list,content,callback) {
        try {
            console.log(logPrefix, 'Start getContentDashboard.');
            const url = `checks`;
            const response = yield this.contentRepository.postContent(url,list);
            console.log("result : ",response);
            console.log(logPrefix, 'Finished getContentDashboard.');
            callback && callback(response.data,content,list);
        } catch (e) {
            console.log(logPrefix, 'Failed getContentDashboard.');
            this.openErrorDialog({
                titleText :'컨텐츠 유무 확인 오류',
                text :displayErrorDialogPrompt(e,'컨텐츠 유무 확인중 에러가 발생했습니다.')
            });
        }
    }


    *uploadExcelContent (step,day,dayContent,callback) {
        try {
            const dayType = day % 2 === 0 ? '/even' : '/odd';
            const url = this.getDefaultContentUrl(step,day) + dayType;
            yield this.contentRepository.postContent(url,dayContent);
            console.log(`📗 ${logPrefix} Finished in Step : ${step} Day: ${day} `);
        } catch (e) {
            console.log(`📕 ${logPrefix} failed in Step : ${step} Day: ${day} `);
            const obj = {step:step,day:day}
            this.setErrorList(obj);
        } finally {
            this.setCurrentUploadCount(this.currentUploadCount  + 1 );
            callback();
        }

    }



    displayExcelUploadErrorResult = () => {

        if (this.ErrorList.length > 0) {
            let text = "";
            this.ErrorList.forEach(error=>{
                text += ` [Step : ${error.step} Day : ${error.day}] \n`;
            })
            this.dialogStore.openNewDialog({
                titleText: "컨텐츠 업로드 오류 목록",
                text:text,
                controlBtn:true,
                clickButton:this.initExcelUploadRelated,
                additionalActionOnClose:this.initExcelUploadRelated
            });
        } else {
            this.initExcelUploadRelated();
        }
    }




    *contentExcelDownload (callback) {
        console.log( "selectExcelFile begins" );
        try {
            const result =  yield axios.get(`/api/v1/content/download`, {
                headers: { 'Content-Type': 'application/vnd.ms-excel' },
                responseType: 'arraybuffer',
            });
            const file = result.data;
            const fileName = this.getResponseFileName( result.headers['content-disposition'] );
            fileDownload( file, fileName );
        } catch ( e ) {
            console.log(e);
        } finally {
            callback && callback();
        }
    }

    getResponseFileName = contentDisposition => {
        let fileName = 'unknown';
        if ( contentDisposition ) {
            const findFileName = decodeURIComponent( contentDisposition )
                .split( ';' )
                .filter( value => value.indexOf( 'filename' ) > -1 )
                .map( value => value.replace( /"/g,  '' ).split( '=' )[1]
                );
            if ( findFileName[0] ) fileName = findFileName[0];
        }
        return fileName;
    };



    openErrorDialog = (info) => {
        if (this?.dialogStore){
            this.dialogStore.openErrorDialog(info)
        }
    }

    *uploadFinalTest (file, callback) {
        this.commonStore.setLoadingState("엑셀 파일을 업로드하는 중입니다.");
        try {
            console.log(logPrefix, 'Start uploadFinalTest.');
            const param = new FormData();
            const fileData = Buffer.from(yield file.arrayBuffer()).toString('base64');
            const blobFile = base64StringToBlob(fileData, "application/octet-stream");

            param.append('file', blobFile, file.name);
            yield this.contentRepository.postFinalTest(param);
            console.log(logPrefix, 'Finished uploadFinalTest.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed uploadFinalTest.');
            this.openErrorDialog({
                titleText: '엑셀 업로드 오류',
                text: displayErrorDialogPrompt(e, '엑셀 파일을 업로드하는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }
}

